import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { HttpMethods } from 'consts/httpMethods';
import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { upsertUser } from 'modules/settings/api';
import { UserManagementContext } from 'modules/settings/routes/UserManagementContext';

export const useMutationUpsertUser = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { successToast, errorToast } = useCustomToast();

  const { setUserVisibilityState } = useContext(UserManagementContext);

  const { mutateAsync, isLoading, isError, data } = useMutation(upsertUser, {
    onSuccess: response => {
      const responseMethod = response?.config?.method;
      const firstName = response?.data?.firstName;
      const lastName = response?.data?.lastName;
      const name = `${firstName} ${lastName}`;
      let successMessage = '';

      if (responseMethod === HttpMethods.PUT) {
        successMessage = t('User successfully updated', { who: name });
        successToast(successMessage);
      } else if (responseMethod === HttpMethods.POST) {
        setUserVisibilityState({
          warningInvitationModalUsername: name,
          warningInvitationModalVisible: true,
        });
      }

      queryClient.invalidateQueries(QUERY_KEYS.SETTINGS_PROFILE_USERS);
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.ErrorDescription;
      errorToast(t(errorMessage));
    },
    onSettled: () => queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_UPSERT_USER),
  });

  return {
    upsertUserMutate: mutateAsync,
    upsertUserLoading: isLoading,
    upsertUserError: isError,
    upsertUserData: data,
  };
};
